import {
  ApplicationActions,
  JobApplicationFooBar,
  JobApplicationSource,
  JwtResponse,
} from '@borg/types';

class JobApplicationsService {
  async getOneForJob(jobId: string, source?: JobApplicationSource) {
    const response = await http.get<JobApplicationFooBar>(`/jobs/${jobId}/applications/me`, {
      params: { source },
    });

    return response.data;
  }

  async save(id: string, data: JobApplicationFooBar['data']) {
    const response = await http.put<JobApplicationFooBar>(`/applications/${id}`, data);
    return response.data;
  }

  async createAccount(id: string) {
    const response = await http.post<JwtResponse>(`/applications/${id}/account`);
    return response.data;
  }

  async saveSearch(id: string) {
    const response = await http.post<JwtResponse>(`/applications/${id}/saved-search`);
    return response.data;
  }

  async startVerification(id: string) {
    const response = await http.post(`/applications/${id}/start-verification`);
    return response.status >= 200 && response.status < 300;
  }

  async complete(id: string, verificationCode?: string) {
    const response = await http.post<ApplicationActions>(`/applications/${id}/complete`, {
      verificationCode,
    });
    return response.status >= 200 && response.status < 300 ? response.data : undefined;
  }

  async cancel(id: string) {
    const response = await http.post(`/applications/${id}/cancel`);
    return response.status >= 200 && response.status < 300;
  }
}

export const jobApplicationsService = new JobApplicationsService();
